import * as React from 'react';
import { IconChevronLeft16, IconChevronRight16 } from '@cian/ui-kit';
import cn from 'classnames';

import * as styles from './styles.css';

export interface INavigationRef {
  prev: HTMLButtonElement | null;
  next: HTMLButtonElement | null;
}

interface INavigationComponentProps {
  className?: string;
}

const NavigationComponent: React.ForwardRefRenderFunction<INavigationRef, INavigationComponentProps> = (props, ref) => {
  const prevButtonRef = React.useRef<HTMLButtonElement>(null);
  const nextButtonRef = React.useRef<HTMLButtonElement>(null);

  const handleButtonClick = React.useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
  }, []);

  React.useImperativeHandle(ref, () => ({
    get prev() {
      return prevButtonRef.current;
    },
    get next() {
      return nextButtonRef.current;
    },
  }));

  return (
    <>
      <button
        className={cn(styles['button'], styles['button--left'], props.className)}
        ref={prevButtonRef}
        data-testid="swiper-prev-button"
        onClick={handleButtonClick}
      >
        <IconChevronLeft16 display="block" />
      </button>
      <button
        className={cn(styles['button'], styles['button--right'], props.className)}
        ref={nextButtonRef}
        data-testid="swiper-next-button"
        onClick={handleButtonClick}
      >
        <IconChevronRight16 display="block" />
      </button>
    </>
  );
};

export const Navigation = React.forwardRef<INavigationRef, INavigationComponentProps>(NavigationComponent);
